import { render } from "./TablaRegistrosComprados.vue?vue&type=template&id=52794bd4&scoped=true"
import script from "./TablaRegistrosComprados.vue?vue&type=script&lang=js"
export * from "./TablaRegistrosComprados.vue?vue&type=script&lang=js"

import "./TablaRegistrosComprados.vue?vue&type=style&index=0&id=52794bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52794bd4"]])

export default __exports__